import dayjs, { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  Grid,
  FormControl,
  Divider,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  CircularProgress,
  FormHelperText,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker, PickersDay } from '@mui/x-date-pickers';
import { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../utils/hooks';
import { calculateTariffsAdditional } from '../../store/thunks/contribution.thunk';
import { SelectChangeEvent } from '@mui/material';
import { PickersDayProps } from '@mui/x-date-pickers';
import AppConsts from '../../config/appconst';
import 'dayjs/locale/de';
import {
  clearPersonResults,
  setIsTariffClicked,
} from 'src/store/reducers/contribution.reducer';

dayjs.locale('de');

interface Props {
  index: number;
  lenght: number;
  removeComponent: (index: number) => void;
  birthdate: string;
  genderProp: string;
  setIsChangeDetected: any;
}
export default function ContributionInfo({
  removeComponent,
  index,
  lenght,
  birthdate,
  genderProp,
  setIsChangeDetected,
}: Props) {
  const { isColorBlindMode, mandant } = useAppSelector((state) => state.config);

  const initialValueBirthDate = birthdate ? dayjs(birthdate) : null;
  const [birthDate, setBirthDate] = useState<Dayjs | null>(
    initialValueBirthDate,
  );
  const [date, setDate] = useState<string | undefined>(
    dayjs(birthdate).format('YYYY-MM-DD').substring(0, 10),
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isDateValid, setIsDateValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const dispatch = useAppDispatch();
  const { commencementDate, pending, personsId, selectedTariffs } =
    useAppSelector((state) => state.contribution);
  const handleDateChange = (newValue: Dayjs | null) => {
    setDate(newValue?.format('YYYY-MM-DD').substring(0, 10));
    setBirthDate(newValue);
    setIsChangeDetected({
      change: true,
      personsId: index,
    });

    if (personsId[index - 1]) {
      dispatch(clearPersonResults(personsId[index - 1]));
    }

    if (
      newValue &&
      dayjs(newValue).isValid() &&
      dayjs(newValue).isBefore(dayjs())
    ) {
      setIsDateValid(true);
      setErrorMessage('');
    } else {
      setIsDateValid(false);
      setErrorMessage('Ungültiges Datum');
    }
  };
  const [gender, setGender] = useState(genderProp);

  const handleGender = (event: SelectChangeEvent) => {
    setGender(event.target.value);
    setDate(birthDate?.format('YYYY-MM-DD').substring(0, 10));
    setIsChangeDetected({
      change: true,
      personsId: index,
    });

    if (personsId[index - 1]) {
      dispatch(clearPersonResults(personsId[index - 1]));
    }
  };
  useEffect(() => {
    if (!pending) setIsLoading(false);
  }, [pending]);
  const calculateTariffsHandle = () => {
    setIsChangeDetected({
      change: true,
      personsId: index,
    });

    if (personsId[index - 1]) {
      dispatch(clearPersonResults(personsId[index - 1]));
    }

    dispatch(setIsTariffClicked());
    setIsLoading(true);
    dispatch(
      calculateTariffsAdditional({
        Id: personsId[index - 1],
        data: {
          customer: {
            birthday: date,
            gender: gender,
            maritalStatus: AppConsts.maritalStatus,
            occupationGroup: AppConsts.occupationGroup,
          },
          responseDescription: AppConsts.responseDescription,
          startDate: commencementDate,
        },
      }),
    );
  };
  const renderCustomDay = (
    day: Dayjs,
    selectedDays: Dayjs[],
    pickersDayProps: PickersDayProps<Dayjs>,
  ) => {
    const { children, ...restProps } = pickersDayProps;
    return (
      <PickersDay
        {...restProps}
        sx={{ fontSize: '13px' }}
        onClick={() => handleDateChange(day)}
      >
        {children}
      </PickersDay>
    );
  };
  const renderCustomDayColorBlind = (
    day: Dayjs,
    _selectedDays: Array<Dayjs | null>,
    pickersDayProps: PickersDayProps<Dayjs>,
  ) => {
    const isSelected = birthDate ? day.isSame(birthDate, 'day') : false;

    return (
      <PickersDay
        {...pickersDayProps}
        disableMargin
        sx={{
          fontSize: '13px',
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 10,
            left: '35%',
            width: '30%',
            borderBottom: '1px solid black',
          },
          ...(isSelected && {
            backgroundColor: 'accessibility.button.main !important',
            color: 'accessibility.button.contrastText',
            '&:hover': {
              backgroundColor: 'accessibility.button.main',
            },
          }),
        }}
      />
    );
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        marginTop={2}
      >
        {lenght > 1 && (
          <Button
            startIcon={<DeleteIcon />}
            onClick={() => removeComponent(index)}
          >
            Person entfernen
          </Button>
        )}
      </Grid>

      <Grid
        container
        spacing={2}
        marginBottom={2}
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              localeText={{ start: 'Gebrutsdatum' }}
            >
              <DatePicker
                inputFormat="DD.MM.YYYY"
                label="Geburtsdatum"
                disableFuture
                value={birthDate}
                onChange={handleDateChange}
                components={{
                  OpenPickerIcon: isColorBlindMode
                    ? () => (
                        <img
                          src={`${window.location.origin}/logos/dateIcon.svg`}
                          alt="Date Icon"
                          style={{
                            width: '24px',
                            height: '24px',
                          }}
                        />
                      )
                    : undefined,
                }}
                renderInput={(params) => (
                  <TextField
                    autoFocus
                    id="standard-basic"
                    variant="filled"
                    {...params}
                    error={!isDateValid}
                    sx={{
                      backgroundColor: 'inputFields.bgColor',

                      input: {
                        color: '#000000',
                      },
                      '.MuiInputBase-root': {
                        backgroundColor: 'inputFields.bgColor',
                      },
                      '.MuiSvgIcon-root': {
                        color: '#000000',
                      },
                      '& .MuiFilledInput-root:before': {
                        borderBottom: '1px solid #000000',
                      },
                      label: {
                        color: '#000000',
                      },
                      '& .Mui-disabled': {
                        backgroundColor: 'inputFields.bgColor',
                      },
                    }}
                  />
                )}
                renderDay={
                  isColorBlindMode ? renderCustomDayColorBlind : renderCustomDay
                }
              />
              <FormHelperText sx={{ color: 'primary.main' }}>
                {' '}
                {errorMessage ? errorMessage : 'TT.MM.JJJJ'}
              </FormHelperText>
            </LocalizationProvider>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl
            variant="filled"
            fullWidth
            sx={{
              '.MuiFilledInput-root': {
                backgroundColor: isColorBlindMode
                  ? '#ffffff'
                  : 'inputFields.bgColor',
                borderBottom: '1px solid #000000',
                '&:hover': {
                  backgroundColor: isColorBlindMode
                    ? '#ffffff'
                    : 'inputFields.bgColor',
                },
                '&.Mui-focused': {
                  backgroundColor: isColorBlindMode
                    ? '#ffffff'
                    : 'inputFields.bgColor',
                },
                '&.MuiInputBase-root.MuiFilledInput-root.Mui-focused': {
                  backgroundColor: isColorBlindMode
                    ? '#ffffff'
                    : 'inputFields.bgColor',
                },
                '&.MuiInputBase-root.MuiFilledInput-root.MuiInputBase-filled': {
                  backgroundColor: isColorBlindMode
                    ? '#ffffff'
                    : 'inputFields.bgColor',
                },
                '&:before, &:after': {
                  borderBottom: 'none !important',
                },
              },
              '.MuiSelect-select': {
                backgroundColor: isColorBlindMode ? '#ffffff' : 'transparent',
              },
              '.MuiSvgIcon-root': {
                color: '#000000',
              },
              label: {
                color: '#000000',
              },
            }}
          >
            <InputLabel id="demo-simple-gender-filled-label">
              Geschlecht
            </InputLabel>
            <Select
              labelId="demo-simple-gender-filled-label"
              id="demo-simple-gender-filled"
              value={gender}
              onChange={handleGender}
            >
              <MenuItem value="MALE">Männlich</MenuItem>
              <MenuItem value="FEMALE">Weiblich</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          <FormControl sx={{ width: '200px' }}>
            <Button
              variant="contained"
              size="large"
              onClick={calculateTariffsHandle}
              disabled={Boolean(
                !date ||
                pending ||
                !gender ||
                commencementDate === 'Invalid Da' ||
                !birthDate ||
                !isDateValid ||
                (mandant === 'hallesche' &&
                  (!selectedTariffs || selectedTariffs.length === 0)),
              )}
              sx={
                isColorBlindMode
                  ? {
                      backgroundColor: 'accessibility.button.main',
                      color: 'accessibility.button.contrastText',
                      textDecoration: 'underline',
                      textUnderlineOffset: '2.5px',
                      '&:hover': {
                        backgroundColor: '#222',
                        color: 'accessibility.button.contrastText',
                        textDecoration: 'underline',
                      },
                      '&.Mui-disabled': {
                        backgroundColor: 'text.disabled',
                        color: 'accessibility.button.contrastText',
                      },
                    }
                  : {}
              }
            >
              Tarife anzeigen
            </Button>
          </FormControl>
        </Grid>
      </Grid>
      <Divider
        sx={{
          borderColor: 'primary.main',
        }}
      />
      {isLoading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '300px',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}
